import EventEmitter from '@tencent/ovb-event-emitter';
export default EventEmitter;
